import {
  mdiBarrel,
  mdiCalendarClock,
  mdiCashMultiple,
  mdiChartLineVariant,
  mdiClockFast,
  mdiCompareHorizontal,
  mdiEarth,
  mdiFactory,
  mdiFire,
  mdiFlash,
  mdiGauge,
  mdiLightningBolt,
  mdiMapMarkerRadiusOutline,
  mdiPalette,
  mdiPickaxe,
  mdiScaleBalance,
  mdiSineWave,
  mdiSwapVertical,
  mdiTransmissionTower,
  mdiTune
} from '@mdi/js';

export const dashboardIcons = {
  forward: {
    oil: mdiBarrel,
    coal: mdiPickaxe,
    emissions: mdiFactory,
    gas: mdiFire,
    electricity: mdiTransmissionTower,
    tbSpreads: mdiCompareHorizontal,
  },
  flex: {
    crossborder: mdiEarth,
    imbalance: mdiScaleBalance,
    intraday: mdiClockFast,
    dayAhead: mdiCalendarClock,
    fcr: mdiSineWave,
    afrr: mdiGauge,
    mfrr: mdiLightningBolt,
    balancing: mdiTune,
    capturePrice: mdiCashMultiple,
    cbmp: mdiPalette,
    congestion: mdiMapMarkerRadiusOutline,
    tbSpreads: mdiSwapVertical,
  },
};

export function getDashboardIcon(category, segmentKey) {
  return dashboardIcons[category]?.[segmentKey] || (category === 'flex' ? mdiFlash : mdiChartLineVariant);
}
